import { render, staticRenderFns } from "./ModalEditHouse.vue?vue&type=template&id=6676edbe&scoped=true&"
import script from "./ModalEditHouse.vue?vue&type=script&lang=js&"
export * from "./ModalEditHouse.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditHouse.vue?vue&type=style&index=0&id=6676edbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676edbe",
  null
  
)

export default component.exports